import { Alert, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { renderGoogleLoginButton } from './LoginUtils';

/**
 * LoginScreen component - displays a login screen with Google Sign-In button
 * @param {Object} props
 * @param {Function} props.onGoogleLoginSuccess - Callback function called after successful login
 */
export default function LoginScreen({ onGoogleLoginSuccess }) {
    const [showInactivityMessage, setShowInactivityMessage] = useState(false);

    useEffect(() => {
        renderGoogleLoginButton("googleLogin", onGoogleLoginSuccess);

        // Check if user was logged out due to inactivity
        const inactivityLogout = sessionStorage.getItem('inactivityLogout');
        if (inactivityLogout === 'true') {
            setShowInactivityMessage(true);
            // Clear the flag after displaying
            sessionStorage.removeItem('inactivityLogout');
        }
    }, [onGoogleLoginSuccess]);

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: '100vh',
            background: 'var(--background-color)',
            color: 'var(--text-primary)'
        }}
        >
            {showInactivityMessage && (
                <Alert
                    severity="info"
                    sx={{
                        mb: 3,
                        maxWidth: '500px',
                        width: '100%',
                        borderRadius: '8px',
                        backgroundColor: 'var(--surface-color)',
                        border: '1px solid var(--border-color)',
                        color: 'var(--text-primary)',
                        '& .MuiAlert-icon': {
                            color: 'var(--text-secondary)'
                        },
                        '& .MuiAlert-message': {
                            color: 'var(--text-primary)',
                            fontSize: '0.875rem',
                            lineHeight: 1.6
                        }
                    }}
                >
                    Session Expired. For your security, you have been logged out due to inactivity.
                </Alert>
            )}
            <Typography
                variant="h6"
                sx={{
                    color: 'var(--text-primary)',
                    fontWeight: 500,
                    mb: 2
                }}
            >
                Please sign-in to continue
            </Typography>
            <Button
                component="div"
                id="googleLogin"
                sx={{
                    background: 'var(--button-gradient)',
                    color: 'white',
                    fontWeight: 600,
                    textTransform: 'none',
                    borderRadius: '12px',
                    px: 3,
                    py: 1.5,
                    boxShadow: '0 4px 15px rgba(212, 175, 55, 0.4)',
                    '&:hover': {
                        background: 'var(--button-gradient-hover)',
                        boxShadow: '0 8px 25px rgba(212, 175, 55, 0.5)',
                        transform: 'translateY(-2px)'
                    }
                }}
            >
                Login
            </Button>
            <Typography
                variant="body2"
                component="div"
                sx={{
                    marginTop: 3,
                    marginBottom: 2,
                    color: 'var(--text-primary)',
                    maxWidth: '500px',
                    textAlign: 'center',
                    fontSize: '0.875rem',
                    lineHeight: 1.6
                }}
            >
                Login to ensure secure access to case documents
            </Typography>
        </div>
    );
}

